import { RobotExcitedIcon } from './RobotExcitedIcon';

/**
 * author: Colton Wiscombe
 * id B32D5968-FE0C-46FB-916E-52D0103DA2C7
 * name robot-excited
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-excited.svg
 * tags
 */
export const EmojiRobotExcitedIcon = RobotExcitedIcon;
export default EmojiRobotExcitedIcon